import { useEffect, useState } from "react"
import { Form } from "react-bootstrap"
import i18n from "../i18n/i18n"

const PlacesSearchBar = ({ defaultValue, onChange, placeholder, style }) => {

    const [event, setEvent] = useState(null)

    useEffect(() => {
        onChange?.(event)
        const container = window.document.querySelector('.pac-container');
        const exists = container?.querySelector('#around-me')
        if (container && !exists) {
            const newDiv = document.createElement('div');
            newDiv.textContent = i18n.t('near_me');
            newDiv.className = 'pac-item around-me';
            newDiv.id = 'around-me'
            container.insertBefore(newDiv, container.firstChild);
        }
    }, [event])

    useEffect(() => {
        return () => {
            const container = document.querySelectorAll('.pac-container')
            container?.forEach?.((item) => {
                item && item?.parentNode.removeChild?.(item)
            })
        }
    }, [])


    return (
        <Form.Control
            style={{
                ...style
            }}
            type="text"
            placeholder={placeholder}
            id="pac-input"
            defaultValue={defaultValue}
            onFocus={(e) => {
                if (e.target.value == i18n.t('near_me')) {
                    e.target.value = ''
                }
                const container = document.querySelector('.pac-container')
                container?.classList.remove('dis-none')
                container?.classList.add('dis-block')
            }}
            onInput={(e) => {
                setEvent(e)
            }}
            onChange={(event) => {
                setEvent(event)
            }}
        />
    )
}

export default PlacesSearchBar;